import { currentUser, findSimPDPGrid } from './utils';
import { get } from 'svelte/store';

export const getToken = () => {
	return get(currentUser).accessToken ? get(currentUser).accessToken : null;
};
export const configsUrl = () => {
	const configsStaging = 'https://beta-sb-app-configs-vlwut6qbsq-ew.a.run.app';
	const configsLive = 'https://sb-app-configs-jtdpxp3bfa-ew.a.run.app';
	return [true, 'true'].includes(process['env'].PROD_ENV) ? configsLive : configsStaging;
};

export const authUrl = () => {
	return [true, 'true'].includes(process['env'].PROD_ENV)
		? 'https://auth.shopbox.ai'
		: 'https://beta-sb-auth-vlwut6qbsq-ew.a.run.app';
};

export const addClient = (clientData) => {
	return fetch(authUrl() + '/api/v2/clients', {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(clientData)
	}).then(async (res) => {
		const json = await res.json();
		if (res.ok) {
			return json;
		} else {
			throw new Error(json.detail);
		}
	});
};

export const generateConfigs = async (id, source) => {
	let params = `/defaults?cid=${id}&token=${getToken()}`;
	if (source) params += `&source=${source}`;
	await fetch(configsUrl() + params, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json'
		}
	});
};

export const generateGrids = async (cid) => {
	const params = `/configs/homepage/customer/${cid}?token=${getToken()}`;
	await fetch(configsUrl() + params, {
		method: 'POST',
		headers: {
			Accept: 'application/json, text/plain, */*',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(findSimPDPGrid)
	});
};
export const disableClient = async (cid) => {
	let config = await getBackendConfig(cid);
	if (config) {
		config.active = false;
		config.traffic = 0;
		const params = `/configs/backend/customer/${cid}?token=${getToken()}`;
		await fetch(configsUrl() + params, {
			method: 'POST',
			headers: {
				Accept: 'application/json, text/plain, */*',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(config)
		});
	} else {
		throw new Error('Client not found');
	}
};

export const addWebsite = (websiteData) => {
	return fetch(authUrl() + '/api/v1/clients/website', {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(websiteData)
	}).then(async (res) => {
		const json = await res.json();
		if (res.ok) {
			return json;
		} else {
			throw new Error(json.detail);
		}
	});
};

export const updateClient = (clientData, id) => {
	return fetch(authUrl() + '/api/v1/clients?cid=' + id, {
		method: 'PATCH',
		headers: {
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(clientData)
	}).then(async (res) => {
		const json = await res.json();
		if (res.ok) {
			return json;
		} else {
			throw new Error(json.detail);
		}
	});
};
export async function getBackendConfig(client) {
	const userToken = `?token=${getToken()}`;
	if (userToken == '?token=undefined') return;
	let url = configsUrl() + `/configs/backend/customer/${client}${userToken}`;

	const res = await fetch(url);
	const json = await res.json();
	return json;
}
